import colorRange from '../../../../commonbase/color/redToGreenColorRange';
import ScoreMeta from './ScoreMeta';
import scoreTypes from '../../../../commonbase/score/scoreTypes';

class UnsatisfactoryToStrongScoreMeta extends ScoreMeta {

  constructor() {
    // super(scoreTypes.poorToStrong);
    super(scoreTypes.unsatisfactoryToStrong);
    this.displayLabelsInsteadOfScores = true;
  }

  shouldRenderEmojiForAssessmentItem = (assessmentItem) => {
    return true;
  };

  getColorRange = () => {
    return colorRange;
  }

}

export default new UnsatisfactoryToStrongScoreMeta();

